module.exports = __webpack_public_path__ + "img/no_image_icon.f3198d14.png";